import { FC, ReactNode } from 'react';
import './header.scss';

export const Header : FC<{children?: ReactNode, title?: ReactNode}> = ({title = ''}) =>
{
    return (
        <div className="header">
            <div className="header__title"><em>McLloyd</em> WebHook</div>
            <div className="header__subtitle">{title}</div>
        </div>
    );
}
